<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import {
        Heading,
        SelectFinanceOption,
        InputVatId,
        SESSION_ORGANIZATION,
        OrganizationForm,
    } from '@smatch/cassiopeia-web-components';

    // TYPES
    import type { Bid, FormComponentLegacy, Organization } from 'src/app/types';

    // CONFIG
    import { BNPL_COUNTRIES } from '../config';

    /* TYPES ----------------------------------------------------------------------------------- */

    type OrganizationWithLegal = Organization & Required<Pick<Organization, 'legal'>>;

    /* PROPS ----------------------------------------------------------------------------------- */

    export let organization: OrganizationWithLegal;
    export let financeOptionCode: Bid['buyer']['financeOptionCode'] | undefined = undefined;

    /* INTERNALS  ------------------------------------------------------------------------------ */

    let Form: FormComponentLegacy | null = null;

    $: ({ countryCode } = organization.legal);

    /* INTERFACE ------------------------------------------------------------------------------ */

    export const submit = async (): Promise<void> => {
        await (Form as FormComponentLegacy).submit();
    };
    export const isValid = (): boolean => (Form as FormComponentLegacy).isValid();

</script>

{#if countryCode === undefined || BNPL_COUNTRIES.includes(countryCode) }

    <div class = 's8-payment'>

        <Heading size = 'md'>Payment Preferences</Heading>

        <div class = 's8-wrap'>

            <div class = 's8-finance'>

                <SelectFinanceOption bind:key = { financeOptionCode } label = { null } />

            </div>

            <div class = 's8-vat'>

                {#if financeOptionCode !== 'no_finance'
                    && $SESSION_ORGANIZATION !== null
                    && $SESSION_ORGANIZATION.legal?.vatId === undefined}

                    <OrganizationForm bind:organization action = 'update' bind:this = { Form }>

                        <InputVatId
                            bind:value = { organization.legal.vatId }
                            countryCode = { organization.legal.countryCode }
                        />

                    </OrganizationForm>

                {/if}

            </div>

        </div>

    </div>

{/if}

<style lang="postcss">

    div.s8-payment {

        div.s8-wrap {
            display: flex;
            gap: 10px;

            div.s8-vat {
                margin-top: -10px;
            }

            > div {
                flex: 1;
            }
        }
    }

</style>